import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-20">
          <div className="text-center max-w-md mx-auto">
            <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-200 mb-6">
              <i className="ri-ghost-line text-4xl text-foreground-400"></i>
            </div>
            <h1 className="font-heading text-4xl font-bold text-foreground-900 mb-3">404</h1>
            <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
            <p className="text-sm text-foreground-500 mb-8">您访问的页面可能已被移除或不存在</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/"
                className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                返回首页
              </Link>
              <Link
                to="/category/rexue"
                className="px-6 py-2.5 border border-primary-300 text-primary-600 rounded-full text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                浏览漫画
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}